import { useQuery } from "react-query";
import { getAccountTickets } from "../../../api/services";

export const useAccountTickets = (accountNumber: string, status: string) => {
  return useQuery(
    ["accounts/tickets", { accountNumber, status }],
    getAccountTickets,
    {
      enabled: !!accountNumber,
    },
  );
};
